export * from './src/table.module';
export { GalaxyPaginatorText, INDETERMINATE_MAX } from './src/datasource/paginator-text';
export { TableContentFooterComponent } from './src/components/table-content-footer/table-content-footer.component';
